import React from "react";
import { GridLegacy } from "@mui/material";
import CheckBoxedForDocandSettings from "./CheckBoxedForDocandSettings";
import SmetaTabs from "../../../Tools/Tabs/SmetaTabs";
import { SmetaTabItem } from "../../../Tools/Tabs/PinIcons";
import { createGrid } from "../../../rcsgrid/rcsgrid";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function DocInfoAndSettings({ grid }: { grid: createGrid }) {
  function getLink() {
    let link = window.location.href;
    link += `?modal&parsed&docid=${grid.getActiveSource().getFieldTextSync("ID")}&card`;
    link = link.replace(/secid=[0-9]+&?/gm, "");
    const lastLoginDrx = localStorage.getItem("LastLogin");
    const configName = lastLoginDrx?.split(",")?.[0]?.trim();
    if (configName) {
      link += `&configname=${encodeURIComponent(configName)}`;
    }
    return link;
  }

  return (
    <SmetaTabs id="optionsForUser" style={{ width: "100%", height: "97%" }}>
      <SmetaTabItem
        label={"Информация"}
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
          overflow: "hidden",
        }}
      >
        <GridLegacy
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={3}
          sx={{ mt: 1, overflow: "hidden" }}
        >
          <GridLegacy item>
            {`Время создания: ${grid.getActiveSource().getFieldTextSync("CreateTime")}`}
            <br />
            {`Автор: ${grid.getActiveSource().getFieldTextSync("CreateUser")}`}
          </GridLegacy>
          <GridLegacy item>
            {`Время изменения: ${grid.getActiveSource().getFieldTextSync("UpdateTime")}`}
            <br />
            {`Автор: ${grid.getActiveSource().getFieldTextSync("UpdateUser")}`}
          </GridLegacy>
          <GridLegacy item>
            {`Внутренний код: ${grid.getActiveSource().getFieldTextSync("ID")}  `}
            {`Индекс типа: ${grid.doccfgid ? grid.doccfgid : ""}`}
          </GridLegacy>
          <GridLegacy item>
            <a style={{ cursor: "pointer" }} href={getLink()}>
              Ссылка на документ
            </a>
          </GridLegacy>
        </GridLegacy>
      </SmetaTabItem>
      <SmetaTabItem
        label={"Настройки"}
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
          overflow: "hidden",
        }}
      >
        <GridLegacy
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          sx={{ mt: 1, overflow: "hidden" }}
        >
          <GridLegacy item>
            <CheckBoxedForDocandSettings />
          </GridLegacy>
          <GridLegacy item></GridLegacy>
          <GridLegacy item></GridLegacy>
        </GridLegacy>
      </SmetaTabItem>
    </SmetaTabs>
  );
}
